import { Injectable } from '@angular/core';
import { UserFacade } from '@app/core/app-services';

export interface RegionServiceInterface {
  getCountryCode(): string;
}

@Injectable()
export class RegionService implements RegionServiceInterface {

  constructor(private userFacade: UserFacade) { }

  getCountryCode(): string {
    const user = this.userFacade.getCurrentUserSnapshot();
    return user.countryCode.toUpperCase();
  }
}
